var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1800,
    height: 1800,
    viewBox: "0 0 1800 1800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M900 1799C1396.5 1799 1799 1396.5 1799 900C1799 403.495 1396.5 0.998901 900 0.998901C403.495 0.998901 0.998779 403.495 0.998779 900C0.998779 1396.5 403.495 1799 900 1799Z",
    stroke: "url(#paint0_linear_102_3)",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M900 1729.51C1358.12 1729.51 1729.51 1358.12 1729.51 900C1729.51 441.875 1358.12 70.4917 900 70.4917C441.875 70.4917 70.4915 441.875 70.4915 900C70.4915 1358.12 441.875 1729.51 900 1729.51Z",
    stroke: "url(#paint1_linear_102_3)",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M900 1660.03C1319.75 1660.03 1660.03 1319.75 1660.03 900C1660.03 480.25 1319.75 139.974 900 139.974C480.249 139.974 139.974 480.25 139.974 900C139.974 1319.75 480.249 1660.03 900 1660.03Z",
    stroke: "url(#paint2_linear_102_3)",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M900 1590.53C1281.37 1590.53 1590.53 1281.37 1590.53 900C1590.53 518.629 1281.37 209.467 900 209.467C518.629 209.467 209.467 518.629 209.467 900C209.467 1281.37 518.629 1590.53 900 1590.53Z",
    stroke: "url(#paint3_linear_102_3)",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M900 1521.05C1243 1521.05 1521.05 1243 1521.05 900C1521.05 557.004 1243 278.95 900 278.95C557.003 278.95 278.95 557.004 278.95 900C278.95 1243 557.003 1521.05 900 1521.05Z",
    stroke: "url(#paint4_linear_102_3)",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M900 1451.56C1204.62 1451.56 1451.56 1204.62 1451.56 900C1451.56 595.383 1204.62 348.443 900 348.443C595.383 348.443 348.443 595.383 348.443 900C348.443 1204.62 595.383 1451.56 900 1451.56Z",
    stroke: "url(#paint5_linear_102_3)",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M900 1382.07C1166.24 1382.07 1382.07 1166.24 1382.07 900C1382.07 633.758 1166.24 417.926 900 417.926C633.758 417.926 417.926 633.758 417.926 900C417.926 1166.24 633.758 1382.07 900 1382.07Z",
    stroke: "url(#paint6_linear_102_3)",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M900 1312.58C1127.86 1312.58 1312.58 1127.86 1312.58 900C1312.58 672.138 1127.86 487.418 900 487.418C672.137 487.418 487.418 672.138 487.418 900C487.418 1127.86 672.137 1312.58 900 1312.58Z",
    stroke: "url(#paint7_linear_102_3)",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M900 1243.1C1089.49 1243.1 1243.1 1089.49 1243.1 900C1243.1 710.512 1089.49 556.901 900 556.901C710.512 556.901 556.901 710.512 556.901 900C556.901 1089.49 710.512 1243.1 900 1243.1Z",
    stroke: "url(#paint8_linear_102_3)",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M900 1173.61C1051.11 1173.61 1173.61 1051.11 1173.61 900C1173.61 748.892 1051.11 626.394 900 626.394C748.892 626.394 626.394 748.892 626.394 900C626.394 1051.11 748.892 1173.61 900 1173.61Z",
    stroke: "url(#paint9_linear_102_3)",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M900 1104.12C1012.73 1104.12 1104.12 1012.73 1104.12 900C1104.12 787.266 1012.73 695.877 900 695.877C787.266 695.877 695.877 787.266 695.877 900C695.877 1012.73 787.266 1104.12 900 1104.12Z",
    stroke: "url(#paint10_linear_102_3)",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M900 1034.63C974.354 1034.63 1034.63 974.354 1034.63 900C1034.63 825.646 974.354 765.37 900 765.37C825.646 765.37 765.369 825.646 765.369 900C765.369 974.354 825.646 1034.63 900 1034.63Z",
    stroke: "url(#paint11_linear_102_3)",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_3",
    x1: 900,
    y1: 0.998901,
    x2: 900,
    y2: 1799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_102_3",
    x1: 900,
    y1: 70.4917,
    x2: 900,
    y2: 1729.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_102_3",
    x1: 900,
    y1: 139.974,
    x2: 900,
    y2: 1660.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_102_3",
    x1: 900,
    y1: 209.467,
    x2: 900,
    y2: 1590.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_102_3",
    x1: 900,
    y1: 278.95,
    x2: 900,
    y2: 1521.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_102_3",
    x1: 900,
    y1: 348.443,
    x2: 900,
    y2: 1451.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_102_3",
    x1: 900,
    y1: 417.926,
    x2: 900,
    y2: 1382.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_102_3",
    x1: 900,
    y1: 487.418,
    x2: 900,
    y2: 1312.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_102_3",
    x1: 900,
    y1: 556.901,
    x2: 900,
    y2: 1243.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_102_3",
    x1: 900,
    y1: 626.394,
    x2: 900,
    y2: 1173.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_102_3",
    x1: 900,
    y1: 695.877,
    x2: 900,
    y2: 1104.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_102_3",
    x1: 900,
    y1: 765.37,
    x2: 900,
    y2: 1034.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroCircles);
export default __webpack_public_path__ + "static/media/hero-circles.9508bf706a85408a25e0b23fd51982ea.svg";
export { ForwardRef as ReactComponent };